// Carries the backend `error_code` (e.g. "invalid_broadcast", "forbidden")
// alongside the human-readable message so callers can branch on the
// canonical code instead of parsing the message string.
export class ApiError extends Error {
  code?: string

  constructor(message: string, code?: string) {
    super(message)
    this.name = 'ApiError'
    this.code = code
  }
}
